// Shared org-profile options. Display-only helpers: backend values stay canonical (no migration).

// Quick-access source markets (frequent). Legacy label "Émirats A.U." kept as-is to preserve
// existing stored values (no auto-normalization). New markets are added from lib/countries.js.
export const QUICK_MARKETS = [
  "États-Unis", "Royaume-Uni", "Allemagne", "France", "Pays-Bas", "Belgique", "Suisse",
  "Émirats A.U.", "Brésil", "Japon", "Inde", "Chine", "Canada", "Australie", "Italie", "Espagne",
];

// FR labels for the canonical (English) objective values. The stored/sent value NEVER changes;
// this is display-only with a raw-value fallback for anything unmapped.
export const OBJECTIVE_LABELS_FR = {
  "Increase revenue": "Augmenter le chiffre d'affaires",
  "Develop low season": "Développer la basse saison",
  "Find new source markets": "Trouver de nouveaux marchés émetteurs",
  "Improve occupancy": "Améliorer le taux d'occupation",
  "Develop distribution": "Développer la distribution",
  "Activate partners": "Activer les partenaires",
  "Improve visitor dispersion": "Améliorer la dispersion des visiteurs",
  "Measure performance": "Mesurer la performance",
};

export const objectiveLabel = (value) => OBJECTIVE_LABELS_FR[value] || value;
